import React from 'react';
import ReactDOM from 'react-dom';

import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';

import Store from '@store/store';

import './index.css';

import App from './app';
import reportWebVitals from './reportWebVitals';

const link = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI,
  credentials: process.env.REACT_APP_GRAPHQL_CREDENTIALS,
});

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    typePolicies: {
      Book: {
        fields: {
          bookmarks: {
            merge(existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
});

/* удаление стилей при копировании в буфер обмена */
document.addEventListener('copy', function(e) {
  const text_only = document.getSelection().toString();
  const clipdata = e.clipboardData || window.clipboardData;
  clipdata.setData('text/plain', text_only);
  clipdata.setData('text/html', text_only);
  e.preventDefault();
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Store>
        <App />
      </Store>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
